/* istanbul ignore file */

export const DeviceKeys = {
  Computers: 'Computers',
  Tablets: 'Tablets',
  Smartphones: 'Smartphones',
  ConnectedTVs: 'ConnectedTVs',
};
